import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';

import { StripeAccount } from '../../types/Stripe';

type Props = {
  stripeAccounts?: StripeAccount[];
  stripeConnectedAccounts?: StripeAccount[];
};
const VendorConnectedStripeAccountsList = ({
  stripeConnectedAccounts = [],
}: Props) => {
  const renderTable = (stripeConnectedAccounts: StripeAccount[]) => {
    return (
      <>
        {stripeConnectedAccounts.map(item => (
          <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.email}</td>
            <td>{item.businessName || ''}</td>
            <td>
              {item.created
                ? moment(item.created).format('MM-DD-YYYY hh:mm:ss')
                : ''}
            </td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Activated</th>
            <th>Email</th>
            <th>Name</th>
            <th>Created</th>
            <th />
          </tr>
        </thead>
        <tbody>{renderTable(stripeConnectedAccounts)}</tbody>
      </Table>
    </div>
  );
};

export default VendorConnectedStripeAccountsList;
